import { action } from '@play-co/replicant';
import * as Conversation from '.';
import { Dialog } from './conservation.ruleset';
import createActions from '../config/actions/createActions';

export const conversationActions = createActions({
  incrementDialogTimesSeen: action((state, dialogId: Dialog['id']) => {
    Conversation.modifiers.incrementTimesSeen(state, dialogId);
  }),

  saveConversationAnswer: action(
    (state, answer: { answerVar: string; key?: string; value: string }) => {
      Conversation.modifiers.saveAnswer(state, answer);
    },
  ),
});
